<template>
  <!-- 横向商品 -->
  <div v-if="showType == 'row'" class="img-text-row" @click="goProductDetails(product)">
    <div class="row-goods-img">
      <img :src="product.goods_pic" alt="" />
    </div>

    <div class="row-goods-info">
      <p class="row-goods-leble">
        <van-tag color="#ff5000" type="primary" size="medium">推荐</van-tag>
      </p>
      <p class="row-goods-name van-multi-ellipsis--l2">{{product.goods_name}}</p> 
      <p class="row-goods-class">截止：{{product.end_time}}</p>
      <p class="row-goods-original-price" v-if="product.goods_desc"> {{product.goods_desc}}</p>
      <p class="row-goods-price">¥ {{product.goods_price}} </p>
    </div>
  </div>

  <div v-else class="img-text-column" @click="goProductDetails(product)">
    <div class="column-goods-img">
      <img :src="product.goods_pic" alt="" />
    </div>

    <div class="column-goods-info">
      <p class="column-goods-name">{{product.goods_name}} </p>
      <div class="column-goods-price">
        <span class="price-l">¥{{product.goods_price}}</span>
        <span class="price-r">去购买</span>
      </div>
    </div>
  </div>

  <!-- "
      end_time: "2024-06-17 00:00:00"
      goods_desc: ""
      goods_id: 5
      goods_name: "乐上LEXONPEANUT背包LNR1510"
      goods_pic: "http://weizhui.xzbfb.com/upload/20221230/00E98157EC2EBDE352A169BAA7392FDE.jpg"
      goods_price: "220.00"
      start_time: "2023-02-17 00:00:00"
      surplus_num: 10
         -->
</template>

<script>
export default {
  name: "imgTextRow",
  props: {
    showType: {
      type: String,
      default: "row", //row column
    },
    product: {
      type: Object,
      default: {
        // brandTitle: "小罐茶",
        // catalogTitle: "家居 / 杯盘餐具",
        // code: "",
        // costPrice: 997,
        // createName: "数据导入",
        // createTime: "2020-09-22 18:20:16",
        // description: "小罐茶铝合金尊享茶盘茶具配件 茶托盘时尚茶盘茶台 茶具盘配件 尊享茶盘",
        // id: "12016",
        // imageUrl: "http://qiniu.zdyxjx.com/product/upload_pic_1600769978539",
        // name: "茶盘茶具配件",
        // quantity: 1000,
        // salePrice: 997,
        // showPrice: 1099,
        // state: 1,
        // supplierName: null,
        // tagTitle: null,
      },
    },
    onlyShow: {
      type: Boolean, //是否跳只读
      default: false,
    },
  },
  components: {},
  data() {
    return {
      ss: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    goProductDetails(product) {
      // console.log(product, "跳详情");
      this.$router.push({ path: `/product-details/${product.goods_id}` });
      // this.$router.push({
      //   name: "product-details",
      //   query: {
      //     productId: product.id,
      //   },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
// 横向
.img-text-row {
  width: 100%;
  height: 150px;
  background-color: #fff;
  //  background-color: palegoldenrod;
  margin-bottom: 5px;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .row-goods-img {
    width: 140px;
    height: 140px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .row-goods-info {
    width: 200px;
    height: 100%;
    padding: 5px 0;
    text-align: left;
    //  background-color: paleturquoise;

    .row-goods-leble {
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #ffffff;
      letter-spacing: 1px;
      text-align: left;
    }
    .row-goods-name {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 500; 
      color: #333333;
      letter-spacing: 1px;
      margin-top: 2px;
      // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
      // overflow: hidden; /*超出的文本隐藏*/
      // text-overflow: ellipsis; /* 溢出用省略号*/
      // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    }
    .row-goods-des {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #78849e;
      letter-spacing: 1px;
      display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
      overflow: hidden; /*超出的文本隐藏*/
      text-overflow: ellipsis; /* 溢出用省略号*/
      -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    }
    .row-goods-class {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #78849e;
      letter-spacing: 1px;
    }
    .row-goods-original-price {
      // text-decoration: line-through;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #cccccc;
    }
    .row-goods-price {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #ff5000;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 10px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 17px;
        color: #cccccc;
      }
    }
  }
}
//竖向

.img-text-column {
  width: 165px;
  padding: 10px;
  //  background-color: palegreen;
  background-color: #fff;
  box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.08);
  border-radius: 10px;
  // float: left;
  margin: 10px 0 0 10px;

  .column-goods-img {
    width: 145px;
    height: 92px;
    margin: 0 auto;
    background-color: #f7f7f7;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .column-goods-info {
    width: 100%;
    height: 62px;
    margin-top: 10px;
    // background-color: papayawhip;
    text-align: left;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .column-goods-name {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      letter-spacing: 1px;
      display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      -webkit-line-clamp: 2; /*显示的行数；如果要设置2行加...则设置为2*/
      overflow: hidden; /*超出的文本隐藏*/
      text-overflow: ellipsis; /* 溢出用省略号*/
      -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    }
    .column-goods-price {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price-l {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #f13535;
      }
      .price-r {
        padding: 3px 10px;
        background: rgba(255, 255, 255, 0.6);
        border: 1px solid #f13535;
        border-radius: 12px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #f13535;
      }
    }
  }
}
</style>
